import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { delay, distinctUntilChanged, filter, NEVER, Observable, of, raceWith, switchMap } from "rxjs";
import { ERoundState } from "../interfaces";
import { GetRoundStateUseCase } from "./get-round-state.use-case";
import { GetUserBetsUseCase } from "./get-user-bets.use-case";
import { map, take } from "rxjs/operators";
import { IUserBet } from "../store/interfaces";
import { RoundRepository } from "../round.repository";

@Injectable()
export class ListenForRoundLosedUseCase implements IUseCase<void, Observable<IUserBet[]>> {
    constructor(private getRoundStateUseCase: GetRoundStateUseCase,
                private roundRepository: RoundRepository,
                private getUserBetsUseCase: GetUserBetsUseCase) {
    }

    execute(): Observable<IUserBet[]> {
        return this.getRoundStateUseCase.execute()
            .pipe(
                distinctUntilChanged(),
                filter((r: ERoundState) => r === ERoundState.Ended),
                switchMap(() => {
                    return this.getUserBetsUseCase.execute().pipe(
                        take(1),
                        filter((bets: IUserBet[]) => {
                            return !!bets.find(b => (b.roundId && b.accumulatedValue >= b.amount));
                        }),
                        switchMap(bets => {
                            const proceed$: Observable<boolean> = of(true).pipe(delay(100));
                            const skip$: Observable<boolean> = this.roundRepository.subscribeToCashOut().pipe(
                                take(1),
                                map(_ => false)
                            );
                            const shouldProceed$: Observable<IUserBet[]> = proceed$
                                .pipe(
                                    raceWith(skip$),
                                    switchMap(proceed => {
                                        if (proceed) {
                                            return of(bets)
                                        }
                                        return NEVER;
                                    })
                                )
                            return shouldProceed$;
                        })
                    );
                }));
    }
}
